<template>
  <div
    :style="containerStyles"
    class="justify-center items-center w-full landing"
    :class="containerClasses"
  >
    <div class="text-red">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  styles: LandingPagesStyles
}>()

const PADDING_TOP_CLASSES: { [key: string]: string } = {
  sm: 'pt-6 md:pt-10',
  lg: 'pt-12 md:pt-20',
}

const PADDING_BOTTOM_CLASSES: { [key: string]: string } = {
  sm: 'pb-6 md:pb-10',
  lg: 'pb-12 md:pb-20',
}

const containerClasses = computed(() => {
  const { stylePaddingTop, stylePaddingBottom, classes } = props.styles
  return [
    PADDING_TOP_CLASSES[stylePaddingTop],
    PADDING_BOTTOM_CLASSES[stylePaddingBottom],
    classes,
  ]
})

const containerStyles = computed(() => ({
  backgroundColor: props.styles.styleBGColor || '#f5f5f5',
  color: props.styles.styleTextColor || '#363636',
}))
</script>
